import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import TransactionForm from '../components/TransactionForm';
import ResultDisplay from '../components/ResultDisplay';
import useAccountingApi from '../../../../hooks/useAccountingApi';

const ExpenseManagement = () => {
  const [formData, setFormData] = useState({
    description: '',
    amount: '',
    expenseType: '',
    paymentMethod: '',
    purpose: ''
  });
  const [showExamples, setShowExamples] = useState(true);
  const [feedbackSubmitted, setFeedbackSubmitted] = useState(false);
  const { loading, error, getSuggestion, submitFeedback } = useAccountingApi();
  const [result, setResult] = useState(null);

  const examples = [
    '직원 급여 지급 - 1월 정기급여',
    '사무실 임대료 지급 - 카드결제',
    '업무용 소모품 구매 - 현금지급'
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = await getSuggestion({
        ...formData,
        category: 'EXPENSE',
        transactionType: 'PAYMENT'
      });
      setResult(data);
    } catch (err) {
      console.error('Error:', err);
    }
  };

  const handleFeedback = async (isHelpful) => {
    try {
      await submitFeedback({
        category: 'EXPENSE',
        isHelpful,
        suggestion: result,
        userInput: formData
      });
      setFeedbackSubmitted(true);
    } catch (err) {
      console.error('Feedback Error:', err);
    }
  };

  const handleReset = () => {
    setFormData({
      description: '',
      amount: '',
      expenseType: '',
      paymentMethod: '',
      purpose: ''
    });
    setResult(null);
    setFeedbackSubmitted(false);
  };

  return (
    <div className="max-w-4xl mx-auto p-6">
      {/* 헤더 섹션 */}
      <div className="mb-8">
        <div className="flex items-center mb-4">
          <Link to="/services" className="text-blue-600 hover:text-blue-700">
            ← 서비스 선택으로 돌아가기
          </Link>
        </div>
        <h1 className="text-2xl font-bold text-gray-900">비용 관리 분개 추천</h1>
        <p className="mt-2 text-gray-600">
          급여, 복리후생, 운영비 등 비용 지출과 관련된 분개를 추천해드립니다.
        </p>
      </div>

      {/* 메인 콘텐츠 */}
      <div className="space-y-8">
        {/* 입력 폼 섹션 */}
        {!result && (
          <div className="bg-white rounded-lg shadow-lg p-6">
            <TransactionForm
              formData={formData}
              setFormData={setFormData}
              onSubmit={handleSubmit}
              loading={loading}
              showExamples={showExamples}
              setShowExamples={setShowExamples}
              examples={examples}
              additionalFields={[
                {
                  name: 'expenseType',
                  label: '비용 유형',
                  type: 'select',
                  options: [
                    { value: 'salary', label: '급여' },
                    { value: 'welfare', label: '복리후생' },
                    { value: 'rent', label: '임차료' },
                    { value: 'supplies', label: '소모품' },
                    { value: 'other', label: '기타' }
                  ]
                },
                {
                  name: 'paymentMethod',
                  label: '지급 방법',
                  type: 'select',
                  options: [
                    { value: 'cash', label: '현금' },
                    { value: 'card', label: '카드' },
                    { value: 'transfer', label: '계좌이체' },
                    { value: 'other', label: '기타' }
                  ]
                }
              ]}
            />
          </div>
        )}

        {/* 에러 메시지 */}
        {error && (
          <div className="p-4 bg-red-100 text-red-700 rounded-lg">
            {error}
          </div>
        )}

        {/* 결과 섹션 */}
        {result && (
          <div className="space-y-6">
            <ResultDisplay
              result={result}
              onFeedback={handleFeedback}
              feedbackSubmitted={feedbackSubmitted}
            />
            <div className="flex justify-center">
              <button
                onClick={handleReset}
                className="px-6 py-2 bg-gray-100 text-gray-600 rounded-lg hover:bg-gray-200 transition-colors"
              >
                새로운 분개 추천받기
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ExpenseManagement; 